module.exports = __webpack_public_path__ + "media/images/admin/profile-5faf09a7795d28bf5a2b48c31da7cff4.png";